<div class="visible-lg">
  <div class="flex-container">
    <div class="bmw-bulletin-container flex-60">
      <div class="bmw-bulletin-title">
        {{getPageTitle()}}
      </div>
      <!-- <form #formeditscopeattern="ngForm" (ngSubmit)="onSubmit(formeditscopeattern)"> -->
      <form #formeditscopeattern="ngForm"
        (ngSubmit)="onSubmit(formeditscopeattern)">
        <div *ngIf='bulletinType === "scope pattern library" && actionType === "edit"'>
          <div class="flex-container">
            <div class="flex-25">
              <ng-container
                *ngIf="( (makeSelectedField.touched || formeditscopeattern.submitted) && makeSelectedField.errors?.defaultSelected); then mandatoryMake; else optionalMake">
              </ng-container>
              <ng-template #mandatoryMake>
                <div>
                  <label class="text-danger">Make*</label>
                </div>
              </ng-template>
              <ng-template #optionalMake>
                <div>
                  <label>Make*</label>
                </div>
              </ng-template>
              <!-- <em
              *ngIf="formeditscopeattern.controls.makeSelected?.invalid && (formeditscopeattern.controls.makeSelected?.touched || mouseoverLogin)">Required</em> -->
              <!-- <div class="bmw-cms-new-bulletin-select"> -->
              <select class="form-control" appSelectValidator="undefined" #makeSelectedField id="makeSelected"
                name="makeSelected" [ngModel]="makeSelected"
                (ngModelChange)="makeSelectedField.value = onMakeSelectionChanged($event)" style="width:80%;"
                [class.field-error]="formeditscopeattern.submitted && makeSelectedField.invalid">
                <option ngValue="undefined" disabled selected> Select</option>
                <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
                <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>
              </select>
              <!-- </div> -->
            </div>
            <div class="flex-25">
              <ng-container
                *ngIf="( (scopePatternField.touched && formeditscopeattern.submitted) && scopePatternField.errors?.defaultSelected && inputMake!==null); then mandatoryScopePattern; else optionalScopePattern">
              </ng-container>
              <ng-template #mandatoryScopePattern>
                <div>
                  <label class="text-danger">SPL Number*</label>
                </div>
              </ng-template>
              <ng-template #optionalScopePattern>
                <div>
                  <label>SPL Number*</label>
                </div>
              </ng-template>
              <!-- <div class="bmw-cms-new-bulletin-select"
                [class.has-error]="(scopePatternField.touched || formeditscopeattern.submitted) && scopePatternField.errors?.defaultSelected"> -->
              <select class="form-control" #scopePatternField="ngModel" appSelectValidator="undefined" id="scopePattern"
                name="scopePattern" [(ngModel)]='scopePatternNumber' style="width:80%;"
                (ngModelChange)="getScopePatternData(scopePatternNumber, makeSelected)">
                <option ngValue="undefined" disabled selected> Select</option>
                <option *ngFor="let scopePatternNumber of ScopePatternNumbersList"
                  [ngValue]="scopePatternNumber.scopePatternDisplayNumber" data-toggle="tooltip"
                  data-container="#tooltip_container" [title]="scopePatternNumber.scopePatternTitle">
                  {{scopePatternNumber.scopePatternDisplayNumber}}
                </option>
              </select>
              <span *ngIf='showAllFields == true'>
                <!-- <small style="color: red">Min. length 6 characters</small> -->
                <small style="font-weight: bold;" [ngStyle]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
                  {{isDocActive ? "Active" : "In-active"}}
                </small>
              </span>
              <!-- <small style="font-weight: bold;margin-left: 10px"
                  [ngStyle]='{"color": isDocActive ? "#59a946" : "#8b928a"}' *ngIf='showAllFields == true'>
                  {{isDocActive ? "Active" : "In-active"}}
                </small> -->
              <div id="tooltip_container"></div>

              <!-- </div> -->
            </div>
            <div class="flex-25">
              <ng-container
                *ngIf="( ( formeditscopeattern.submitted) && mydateField.errors?.required && inputMake!==null); then mandatoryDate; else optionalDate">
              </ng-container>
              <ng-template #mandatoryDate>
                <div>
                  <label class="text-danger">Date*</label>
                </div>
              </ng-template>
              <ng-template #optionalDate>
                <div>
                  <label>Date*</label>
                </div>
              </ng-template>
              <div >
                <input type="date" name="mydate" id="mydate" [(ngModel)]="inputDate" required />
                <!-- <span class="text-danger" *ngIf="( formeditscopeattern.submitted) && mydateField.errors?.required">
                *Required
              </span> -->
              </div>
            </div>
          </div>
          <div *ngIf='showAllFields == true'>
            <!-- <small style="font-weight: bold;margin-left: 10px"
              [ngStyle]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
              {{isDocActive ? "Active" : "In-active"}}
            </small> -->
            <!-- <div class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='relatedSIBs?.length > 0'>
          </div> -->
            <div class="flex-container">
              <div class="flex-87">
                <ng-container
                  *ngIf="( formeditscopeattern.submitted && scopePatternTitleField.errors?.required &&  inputMake!==null); then mandatoryScopePatternTitle; else optionalScopePatternTitle">
                </ng-container>
                <ng-template #mandatoryScopePatternTitle>
                  <div>
                    <label class="text-danger">Title*</label>
                  </div>
                </ng-template>
                <ng-template #optionalScopePatternTitle>
                  <div>
                    <label>Title*</label>
                  </div>
                </ng-template>
                <div>
                  <!-- <em
                  *ngIf="formeditscopeattern.controls.scopePatternTitle?.invalid && (formeditscopeattern.controls.scopePatternTitle?.touched || mouseoverLogin)">Required</em> -->
                  <input type="text" id="scopePatternTitle" name="scopePatternTitle" #scopePatternTitleField="ngModel"
                    required [(ngModel)]="textareaContent">
                  <!-- <span class="text-danger"
                  *ngIf="( formeditscopeattern.submitted) && scopePatternTitleField.errors?.required">
                  *Required
                </span> -->
                </div>
                <!-- <div [hidden]="!formeditscopeattern.submitted || scopePatternTitle.valid" class="alert alert-danger">
                Enter Scope Pattern Title.
              </div> -->
              </div>
            </div>
            <div class="flex-container" style="margin-top: 20px">
              <div class="flex-70">
                <label>E Series*</label><br />
                <ng-multiselect-dropdown #multiSelectSeries id="multiSelectSeries" name="multiSelectSeries"
                  [placeholder]="'Select'" [data]="dropdownESeriesList" [(ngModel)]="seriesFilterList"
                  [settings]="dropdownSettingsSeries" [disabled]="false"
                  (onSelect)='addToNoiseSelection("series",$event)'
                  (onDeSelect)='removeFromNoiseSelection("series",$event)'>
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="flex-container">
              <div>
                <div class="bmw-bulletin-series-chips" *ngFor='let series of seriesFilterList'>
                  {{ series.seriesName }}
                  <!-- <i class="material-icons" (click)='removeFromSelection("series", series)'>close</i> -->
                </div>
              </div>
            </div>
            <div class="flex-container" style="margin-top: 20px">
              <div class="flex-70">
                <label>Signal Name*</label><br />
                <ng-multiselect-dropdown #multiSelectArea id="multiSelectArea" name="multiSelectArea"
                  [placeholder]="'Select'" [data]="dropdownAreaList" [(ngModel)]="areaFilterList"
                  [settings]="dropdownSettingsArea"  [disabled]="false" 
                  (onSelect)='addToNoiseSelection("area",$event)'
                  (onDeSelect)='removeFromNoiseSelection("area",$event)'>
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="flex-container">
              <div>
                <div class="bmw-bulletin-series-chips" *ngFor='let area of areaFilterList'>
                  {{ area.signalName }}
                  <!-- <i class="material-icons" (click)='removeFromSelection("area", area)'>close</i> -->
                </div>
              </div>
            </div>

            <!-- Reactivate or Deactivate document  -->
            <div class="flex-container" style="margin-top: 20px">
              <div class="cms-modal-select-make-checkbox">
                <label class="container sm" *ngIf="isDocActive===false || isDocActive===null">Reactivate
                  <input type="checkbox" id="reactivateOTV" name="reactivateOTV" value="reactivate"
                    [(ngModel)]='reactivate' (change)='setReactivate($event)' [disabled]='isDocActive==true'>
                  <span class="checkmark"></span>
                </label>
                <label class="container sm" *ngIf="isDocActive===true">Deactivate
                  <input type="checkbox" id="deactivateOTV" name="deactivateOTV" value="deactivate"
                    [(ngModel)]='deactivate' (change)='setDeactivate($event)' [disabled]='isDocActive==false'>
                  <span class="checkmark"></span>
                </label>
                <!-- <label class="container sm" style="margin-right:0em;width:10em">Deactivate
                  <input type="radio" id="deactivateOTV" name="deactivateOTV" value="deactivate"
                    [(ngModel)]='reactivateOrDeactivate' [disabled]='isDocActive==false'>
                  <span class="checkmark"></span>
                </label> -->
              </div>
            </div>

            <!-- <div class="bmw-cms-pbs-subject">
              <label>Document Name</label>
              <input type="text" id="splDocumentName" name="splDocumentName" #scopePatternTitleField="ngModel"
                    required [(ngModel)]="splDocumentName">
            </div> -->

            <div class="bmw-cms-modal-button new-bulletin">
              <div class="upload-btn-wrapper flex-150-px">
                <button class="btn pointer">Choose File</button>
                <input type="file" name="myfile" (change)='fileUpload($event)' />
              </div>
              <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
            </div>
            
              <a href='mount/scope_pattern/{{splDocumentName}}' target="_blank">
                <div class="bmw-lg-takata-doc flex-container space-between center">
                  <div class="flex-100">{{splDocumentName}}</div>

                  <div class="flex-8" style="text-align: right">
                    <!-- <i class="material-icons" [ngStyle]='{"color": "#281432"}'>
                      {{ doc.documentFileType === "pdf" ? "picture_as_pdf" : doc.documentFileType === "zip" ? "file_download" : doc.documentFileType
                      === "xlsx" ? "insert_drive_file" : "" }}
                    </i> -->
                  </div>
                </div>
              </a>            
           

            <div class="flex-container">
              <div class="bmw-cms-modal-button new-bulletin">
                <!-- <button [disabled]='!inputMake' class="bmw-button-secondary" (click)='submit()'>Submit</button> -->
                <span *ngIf="errorMessage!==''"><small style="color: red;text-align: left;">
                    <p text-align: left>&nbsp;&nbsp;{{ errorMessage }}</p>
                  </small></span>
                <span
                  *ngIf="formeditscopeattern.touched && formeditscopeattern.invalid && inputMake!==null && formeditscopeattern.submitted"><small
                    style="color: red;text-align: left;">
                    <p text-align: left>Please enter all mandatory fields.</p>
                  </small></span>
                  <button class="bmw-button-secondary" type="submit">Submit</button>
                <!-- <button [disabled]='!inputMake' class="" type="submit">Edit SPL</button> -->
                <!-- <span ><small style="color: red">{{formeditscopeattern.pristine}}</small></span>
              <span ><small style="color: red">{{formeditscopeattern.touched}}</small></span>
              <span ><small style="color: red">{{formeditscopeattern.dirty}}</small></span> -->
              </div>
            </div>
            <!-- <div class="flex-container"> -->
            <!-- <div class="bmw-cms-modal-button new-bulletin" (mouseenter)="mouseoverLogin=true"
              (mouseleave)="mouseoverLogin=false">
              <button (mouseenter)="mouseoverLogin=true" (mouseleave)="mouseoverLogin=false"
                [disabled]='formeditscopeattern.invalid' class="bmw-button-secondary">Submit</button>
            </div> -->
            <!-- <div class="bmw-cms-modal-button new-bulletin">
              <span (mouseenter)="mouseoverLogin=true" (mouseleave)="mouseoverLogin=false">
                <button mat-raised-button (mouseenter)="mouseoverLogin=true" (mouseleave)="mouseoverLogin=false"
                  color="primary" class="btn btn-primary search-btn"
                  [disabled]="formeditscopeattern.invalid">Submit</button>
              </span>
            </div> -->
            <!-- </div> -->
          </div>
        </div>
        <!-- <pre>{{formeditscopeattern.value | json}}</pre>
        <pre>{{inputMake | json}}</pre> -->
      </form>

    </div>
  </div>
</div>